/*
// Self cleaning setInterval hook - Documentation can be found here:
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
// Basic usage:
// Pass a callback function you want to repeat over the interval
// Pass a delay (in milliseconds) after which you want the callback to repeat
// Passing a delay of null will stop the interval code running
*/
import { useEffect, useRef } from 'react'

function useInterval(callback, delay) {
  const savedCallback = useRef();
 
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
 
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      let id = setInterval(tick, delay)

      return () => clearInterval(id)
    }
  }, [delay]);
}

export default useInterval
